import 'intersection-observer';
import createREGL from 'regl';
import wrapper from 'wrapper';
import AtiTracking from './components/atiTracking/atiTracking';
import Scroller from './components/scrolly-custom/Scrolly';
import Chart from './components/dots-visualisation/Chart';
import Visualisation from './components/dots-visualisation/dots-vis';
import AnimationToggle from './components/animation-toggle/animation-toggle';

// enhance core content
wrapper.selectAll('.enhanced-content').forEach((el) => {
    el.style.display = 'block'; // eslint-disable-line no-param-reassign
});
wrapper.select('.scrolly-fallback').style.display = 'none';

wrapper.markPageAsLoaded();

const dotsVis = new Visualisation();
// // initialize regl
createREGL({
    // callback when regl is initialized
    onDone: dotsVis.init.bind(dotsVis),
    container: wrapper.select('.canvas-container'),
    attributes: {
        antialias: true,
    },
});

new Scroller(dotsVis);
new Chart();
new AtiTracking();
new AnimationToggle();
wrapper.select('.chart-title-container').style.display = 'none'; // remove from layout so locust sits higher up the page, brought back in during scrolly
